import styled from "styled-components";

import theme from "config/theme";

import { H4 } from "components/Text";
import StyledImage from "components/Image";

export const Wrapper = styled.a`
  display: block;
  text-align: left;
  margin: 0 5px;
  overflow: hidden;
  transition: ${theme.transition};
  border-radius: ${theme.radius};
  background-color: ${theme.color.paper};

  &:hover {
    transform: scale(0.98) translateZ(0);
    background-color: ${theme.color.paper2};
  }
`;

export const Inner = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 25px;
  min-height: 250px;
`;

export const Title = styled(H4)`
  line-height: 1.3;
  margin-bottom: 10px;
  font-size: ${theme.font.size.delta};
`;

export const Description = styled.div`
  font-size: ${theme.font.size.epsilon};
  color: ${theme.color.gray4};
  margin-bottom: 40px;
  line-height: 1.6;
`;

export const Image = styled(StyledImage)`
  width: 100%;
  display: block;

  img {
    opacity: 1 !important;
  }
`;

export const Details = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  flex: 1;
`;

export const Meta = styled.div`
  display: flex;
  align-items: flex-start;
  margin-top: 5px;
  color: ${theme.color.gray4};
  font-size: ${theme.font.size.zeta};
`;
